module.exports = __webpack_public_path__ + "static/media/michael-browning-MtqG1lWcUw0-unsplash.c64fd869.jpg";